var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnarchiveJob({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.85714 2C3.33053 2 3.71429 2.38376 3.71429 2.85714V6.39972C5.51162 3.74563 8.55126 2 12 2C17.1002 2 21.3074 5.81731 21.9227 10.7511C21.9813 11.2208 21.6479 11.6491 21.1782 11.7077C20.7084 11.7663 20.2801 11.433 20.2216 10.9632C19.712 6.87683 16.2247 3.71429 12 3.71429C8.9935 3.71429 6.35952 5.31577 4.9071 7.71429H8.57143C9.04482 7.71429 9.42857 8.09804 9.42857 8.57143C9.42857 9.04482 9.04482 9.42857 8.57143 9.42857H2.85714C2.38376 9.42857 2 9.04482 2 8.57143V2.85714C2 2.38376 2.38376 2 2.85714 2ZM2.82182 12.2923C3.29156 12.2337 3.71986 12.567 3.77843 13.0368C4.288 17.1232 7.77533 20.2857 12 20.2857C15.0065 20.2857 17.6405 18.6842 19.0929 16.2857H15.4286C14.9552 16.2857 14.5714 15.902 14.5714 15.4286C14.5714 14.9552 14.9552 14.5714 15.4286 14.5714H21.1429C21.6162 14.5714 22 14.9552 22 15.4286V21.1429C22 21.6162 21.6162 22 21.1429 22C20.6695 22 20.2857 21.6162 20.2857 21.1429V17.6003C18.4884 20.2544 15.4487 22 12 22C6.89983 22 2.69256 18.1827 2.07732 13.2489C2.01875 12.7792 2.35207 12.3509 2.82182 12.2923Z",
    fill: "#70758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchiveJob);
export default __webpack_public_path__ + "static/media/unarchive-job.dd42b2057040071dd27cd636fc9d98dc.svg";
export { ForwardRef as ReactComponent };